import { ISelector } from '@omaze/redux';

import { createClosedExperienceSelector } from '../../ClosedExperience.factories';
import { IClosedExperienceState } from '../../ClosedExperience.state';

export const selectShouldRenderNonProfit: ISelector<IClosedExperienceState, boolean> =
    createClosedExperienceSelector((state: IClosedExperienceState): boolean => {
        if (!state.nonProfit) {
            return false;
        }

        return !!(state.nonProfit.name && (state.nonProfit.netRaiseAmount ||
            state.nonProfit.impactMessage ||
            state.nonProfit.thankYouMessage ||
            state.nonProfit.logoURL)
        );
    });
